import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLink, 
  faTrashAlt, 
  faExchangeAlt, 
  faSpinner 
} from '@fortawesome/free-solid-svg-icons';
import { useActions } from '../../contexts/ActionContext';

const FactureItem = ({ facture, onRefresh }) => {
  const { updateFactureVersion, supprimerFacture, isLoading, setLoadingStates } = useActions();
  
  const handleChangeVersion = async (id, currentVersion, e) => {
    e.preventDefault();
    
    // Log the exact parameters we're working with for debugging
    console.log('Change version called with:', {
      id,
      currentVersion,
      typeId: typeof id,
      typeCurrentVersion: typeof currentVersion
    });
    
    if (!id) {
      console.error('Error: Invoice ID is empty. Cannot change version.');
      return;
    }
    
    // Make sure currentVersion is always a string before confirmation
    const version = currentVersion || '';
    const fromVersion = version === 'v2' ? 'v2' : 'standard';
    const toVersion = version === 'v2' ? 'standard' : 'v2';
    
    // Pas de confirmation par pop-up
    // Continuer directement avec l'action
    
    // Set loading state for this specific invoice
    setLoadingStates(prev => ({ ...prev, [`version-${id}`]: true }));
    
    try {
      // Call the context function with clear parameters
      await updateFactureVersion(id, version, onRefresh);
      console.log(`Successfully changed invoice ${id} from ${fromVersion} to ${toVersion}`);
    } catch (error) {
      console.error('Error changing invoice version:', error);
      console.error(`Erreur lors du changement de version: ${error.message}`);
    } finally {
      setLoadingStates(prev => ({ ...prev, [`version-${id}`]: false }));
    }
  };
  
  const handleDelete = async (id, version, e) => {
    e.preventDefault();
    console.log(`Version change for invoice ID: ${id} initiated.`);
    supprimerFacture(id, version, onRefresh);
  };
  
  const factureUrl = `https://airtable.com/app7XWoxwjvdzoSQ1/tblUhRGHSpdVBh8Zz/viwRKXe13sPWV0wHr/${facture.id}?blocks=hide`;
  const remiseStyle = facture.isRemise ? { color: '#10b981', fontWeight: '600' } : {};
  const typeDisplay = facture.type !== 'loyer' ? `- ${facture.type.toUpperCase()}` : '';
  
  return (
    <div style={{ marginBottom: '4px' }}>
      <a href={factureUrl} target="_blank" className="facture-link" style={remiseStyle} rel="noopener noreferrer">
        {facture.date}: {facture.amount}€ <FontAwesomeIcon icon={faLink} className="link-icon" />
      </a> {typeDisplay} 
      
      {/* Badge de version */}
      {facture.version === 'v2' ? (
        <span className="version-badge v2-badge" title="Version V2">V2</span>
      ) : (
        <span className="version-badge regular-badge" title="Version Standard">Standard</span>
      )}
      
      {/* Bouton de changement de version */}
      <a href="#" 
         onClick={(e) => handleChangeVersion(facture.id, facture.version, e)}
         className="version-change-link" 
         title={`Changer en version ${facture.version === 'v2' ? 'standard' : 'V2'}`}>
        {isLoading(`version-${facture.id}`) ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          <FontAwesomeIcon icon={faExchangeAlt} />
        )}
      </a>
      
      {/* Bouton de suppression */}
      <a href="#" 
         onClick={(e) => handleDelete(facture.id, facture.version, e)}
         className="delete-link" 
         title="Supprimer cette facture">
        {isLoading(`delete-${facture.facture_id}`) ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          <FontAwesomeIcon icon={faTrashAlt} />
        )}
      </a>
      
      {/* Détails de la facture */}
      {facture.facture_id && (
        <div className="facture-details" title={facture.facture_id}>
          {facture.facture_id}
        </div>
      )}
    </div>
  );
};

export default FactureItem;
